"use client";
import React from "react";

type SpinnerSize = "sm" | "md" | "lg" | "xl";

export function Spinner({ label, className = "", size = "md" }: { label?: string; className?: string; size?: SpinnerSize }) {
  const iconSize = size === "sm" ? "h-3 w-3" : size === "md" ? "h-4 w-4" : size === "lg" ? "h-6 w-6" : "h-8 w-8";
  const labelSize = size === "sm" ? "text-xs" : size === "md" ? "text-sm" : size === "lg" ? "text-base" : "text-lg";
  return (
    <div className={`flex items-center justify-center gap-2 text-muted-foreground ${className}`} role="status" aria-live="polite">
      <svg className={`${iconSize} animate-spin`} viewBox="0 0 24 24" aria-hidden="true">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      </svg>
      {label && <span className={labelSize}>{label}</span>}
    </div>
  );
}

export default Spinner;
